import React, {Fragment,useEffect,useId,useRef,useState} from 'react'

import axios from 'axios'
import Btn from '../ui/Btn'
import './settings.css'

/*
 * Sport photo uploader.
 *
 * Same contract as before: <FileUploadSports id={...} type="3"/>, the POST goes
 * to admin/sports/photo, and the preview reads admin/filessports/{id}/{t}.
 * Only the surface changed — token-styled controls, a real progress bar and
 * inline messages instead of alert().
 */

const IconPaperclip=()=>(
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M21 11.5 12.5 20a5 5 0 0 1-7-7l8-8a3.5 3.5 0 0 1 5 5l-8 8a2 2 0 0 1-3-3l7.5-7.5"/>
  </svg>
)

const FileUploadSports = (props) => {

    const [file,setFile]=useState('')
    const [fileName,setFileName]=useState('Please select an image file')
    const [upLoading, setUpLoading]=useState(false)
    const [uploadPercentage, setUploadPercentage]=useState(0)
    const [title,setTitle]=useState('')
    const [photo,setPhoto]=useState('')
    /* the preview 404s for a sport that has no photo yet — that is not an error */
    const [broken,setBroken]=useState(false)
    const [note,setNote]=useState(null)

    const inputRef=useRef(null)
    const inputId='st-ups-'+useId()

    useEffect(() => {

        loadFile(props.id)

        if (props.type==3){
            setFileName('Please select an image file')
            setTitle('Upload  Photo.')
        }

    }, [props.type])

    useEffect(()=>{
        loadFile(props.id)
    },[props.id])

    const resetPicker=()=>{
        if (inputRef.current) inputRef.current.value=null
        setFile('')
        setFileName('Please select an image file')
    }

    const fileChanged=e=>{
        setNote(null)
        const picked=e.target.files && e.target.files[0]
        if (!picked){
            resetPicker()
            return
        }

        if (props.type==2 || props.type==3 || props.type==4 || props.type==5){
            if (String(picked.type||'').indexOf('image/')>-1){
                setFile(picked)
                setFileName(picked.name)
            }else{
                resetPicker()
                setNote({tone:'crit',text:'Please Select an IMAGE file'})
            }
        }
    }

    const uploadFile=async e=>{
        e.preventDefault()
        setNote(null)
        const formData=new FormData()
        formData.append('file',file)
        formData.append('id',props.id)
        try{
            setUpLoading(true)
            axios.post(process.env.REACT_APP_API_SERVER+'admin/sports/photo',formData,{
                headers:{
                    'Content-Type':'multipart/form-data',
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                },
                onUploadProgress: ProgressEvent=>{
                    setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded*100/ProgressEvent.total)))
                }
            }).then(res=>{
                setUpLoading(false)
                resetPicker()

                setUploadPercentage(0)

                if (res.data.err==0){
                    loadFile(props.id)
                    setNote({tone:'good',text:'Photo uploaded.'})
                }else{
                    setNote({tone:'crit',text:'An Error has occured! Please Try Again'})
                }

            }).catch(err=>{
                setUpLoading(false)
                setUploadPercentage(0)
                setNote({tone:'crit',text:'Upload failed. Please try again.'})
                console.log(err)
            })

        }catch(err){
            setUpLoading(false)
            setUploadPercentage(0)
            setNote({tone:'crit',text:'Upload failed. Please try again.'})
            console.log(err)
        }
    }

    /* No id, no preview URL. An empty string here would reach the <img> as
       src="", which the browser resolves to the current document — a second
       request for the SPA shell that can never decode as an image. */
    const loadFile=(id)=>{
        const t=Date.now()
        setBroken(false)
        if (id===undefined || id===null || id===''){
            setPhoto('')
            return
        }
        setPhoto(process.env.REACT_APP_API_SERVER+'admin/filessports/'+id+'/'+t)
      }

    return (

        <Fragment>
          <div className="st-up">

            <div className="st-up-head">
              <span className="mono st-up-title">{title}</span>
              <span className="st-up-sub">JPG or PNG. Replaces the current photo.</span>
            </div>

            {note
              ? <div className="st-note" data-tone={note.tone} role="alert">
                  <span className="st-note-text">{note.text}</span>
                </div>
              : null}

            <form className="st-up-form" onSubmit={uploadFile}>
              <div className="st-file-row">
                <input
                  ref={inputRef}
                  className="st-file"
                  required
                  onChange={fileChanged}
                  type="file"
                  accept="image/*"
                  id={inputId}
                />
                <label className="st-file-label" htmlFor={inputId}>
                  <IconPaperclip/>
                  Choose file
                </label>
                <span className="st-file-name" data-set={file ? '1' : '0'}>{fileName}</span>
              </div>

              {upLoading
                ? <div>
                    <div className="st-up-progress">
                      <span className="st-up-fill" style={{width:uploadPercentage+'%'}}></span>
                    </div>
                    <div className="st-up-pct">
                      <b>{uploadPercentage}%</b>
                      <span>Uploading — please wait.</span>
                    </div>
                  </div>
                : null}

              <div className="st-up-actions">
                <Btn variant="accent" type="submit" disabled={upLoading}>
                  Upload {props.type==1 ? 'Video' : 'Photo'}
                </Btn>
              </div>
            </form>

            <div className="st-up-media">
              {photo && !broken
                ? <img
                    className="st-up-img"
                    src={photo}
                    alt=""
                    onError={()=>setBroken(true)}
                  />
                : <span className="st-hint">No photo yet.</span>}
            </div>

          </div>
        </Fragment>
    )

}

export default FileUploadSports;
